// @flow
import React from 'react';

import type {
  FilterOption,
  Filters,
  FilterOptions,
  FilterType,
} from 'chronos-types';

import {
  Popup,
} from 'chronos-components';

import FilterInput from './FilterInput';
import FilterSelect from './FilterSelect';
import FilterSelectedList from './FilterSelectedList';

import * as S from './styled';


type Props = {
  profile: any,
  /**
   * Selected filter type
   * */
  selectedType: FilterType,
  /**
   * Already selected filters.
   * */
  selectedFilters: Filters,
  /**
   * Type options
   * */
  typeOptions: FilterOptions,
  /**
   * Filter open state
   * */
  isOpen: Boolean,
  /**
   * Function that is called after remove filter.
   * */
  onRemove: { ({ selectedType: FilterType, option: FilterOption }): void },
  /**
   * Function that is called whenever the filter itself changes.
   * */
  onAdd: { ({ selectedType: FilterType, option: FilterOption }): void },
  /**
   * Function that is called whenever the filter type of the changes.
   * */
  onTypeChange: { (value: FilterType): void },
  /**
   * Function that is called whenever the filter open state changes
   * */
  onVisibilityChange: { (isOpen: Boolean): void },
  /**
   * Function to load options
   * */
  loadOptions: { (search: string): void },
};

const Filter = ({
  profile,
  selectedType,
  selectedFilters,
  typeOptions,
  isOpen,
  loadOptions,
  onRemove,
  onAdd,
  onTypeChange,
  onVisibilityChange,
}: Props) => (
  <S.Filter>
    <Popup
      place="below"
      isOpen={isOpen}
      trigger={(
        <FilterInput
          profile={profile}
          selectedFilters={selectedFilters}
          onRemove={onRemove}
        />
      )}
      setPopupVisible={() => {
        onVisibilityChange(!isOpen);
      }}
      handleOuterAction={(ev: any) => {
        ev.preventDefault();
        onVisibilityChange(
          ev.composedPath().some(
            el => (
              el.className
              && el.className.indexOf('chronosPopupSelect') !== -1
            ),
          ),
        );
      }}
    >
      <S.PopupContent>
        <S.PopupInner>
          <S.PopupBody>
            <S.PopupSelectContent>
              <FilterSelect
                selectedType={selectedType}
                selectedFilters={selectedFilters}
                typeOptions={typeOptions}
                loadOptions={loadOptions}
                onAdd={onAdd}
                onRemove={onRemove}
                onTypeChange={onTypeChange}
              />
            </S.PopupSelectContent>

            <S.PopupListContainer>
              <FilterSelectedList
                selectedType={selectedType}
                selectedFilters={selectedFilters}
                onRemove={onRemove}
              />
            </S.PopupListContainer>
          </S.PopupBody>
        </S.PopupInner>
      </S.PopupContent>
    </Popup>
  </S.Filter>
);

export default Filter;
